module.exports = __webpack_public_path__ + "static/media/open-lock.2073f57d.svg";